import('./product_title.css')

export default function(opts = {}){
    let ugrhi_name = opts.ugrhi_name
    let container = opts.container
    let elements = {}
    init()

    function init(){
        elements.container = createElement('div','product-main-title-container')
        elements.title = createElement('div','title')
        elements.clock = createElement('div','clock-container')
        $(elements.clock).append('<div class="clock-pointer"></div>')
        // $(elements.title).html('CHUVA <br><div class="clock-container"><div class="clock-pointer"></div></div> AGORA')
        $(elements.title).html('<div class="product-main-title">CHUVA AGORA</div><div class="product-main-subtitle">SIBH</div>')
        $(elements.container).append(elements.title)
        $(container).append(elements.container)
    }

    function createElement(type, classes){
        let el = document.createElement(type)
        $(el).addClass(classes)
        return el 
    }
}